// src/components/shared/ConfirmModal.jsx
import React from 'react';
import Modal from './Modal';

const ConfirmModal = ({
  isOpen,
  onClose,
  onConfirm,
  title = "Bestätigung",
  message,
  confirmText = "Ja, bestätigen",
  cancelText = "Abbrechen",
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      footer={
        <>
          <button className="cancel-button" onClick={onClose}>
            {cancelText}
          </button>
          <button className="deactivate-button" onClick={onConfirm}>
            {confirmText}
          </button>
        </>
      }
    >
      <p>{message}</p>
    </Modal>
  );
};

export default ConfirmModal;